/*
一次充电成功率
 */
import React, { Component } from "react";
import "@/assets/stylus/data_analysis.styl";
import PropTypes from "prop-types";
import "@ant-design/compatible/assets/index.css";
import { Affix } from "antd";
import FormCore from "@/components/display/form/formCore";
import CityDataFilterHoc from "@/hoc/form/cityDataHoc";
import moment from "moment";
import { connect } from "react-redux";
import { injectIntl } from "react-intl";
import ChargeSuccessDay from "./chargeSuccessDay";
import StopReason from "./stopReason";
import Top100Equipment from "./top100Equipment";

import { getEquSuccessRate, getStationOrEquStopReason } from "../../../fetch/fetchApi";
import fetchHandler from "../../../fetch/fetchHandler";
import "./index.styl";

// 国际化切换语言

const SORT_TYPE_OPTIONS = [
  // value替换为对应字段
  { name: "订单总数", value: "0" },
  { name: "成功订单数", value: "1" },
  { name: "失败订单数", value: "2" },
  { name: "成功率", value: "3" },
];

const SORT_ORDER_OPTIONS = [
  { name: "从高到低", value: "-1" },
  { name: "从低到高", value: "1" },
];

@CityDataFilterHoc
@connect((state) => state)
class StationChargeDetail extends Component {
  constructor(props) {
    super(props);
    this.props = props;
    this.internationalization = this.props.intl.messages.chargSuccess;

    this.props = props;
    this.state = {
      formConfig: null,
      monthDataList: [], // 按月呈现数据源
      dailyDataList: [], // 按日呈现数据源
      stopReasonDataList: [], // 停止原因数据源
      title: window.LayoutTab.tabParam.stationInfo.stubGroupName,
      params: {
        successType: "1",
        startTime: moment().subtract(7, "d").format("YYYYMMDD"),
        endTime: moment().format("YYYYMMDD"),
        stubGroupId: window.LayoutTab.tabParam.stationInfo.stubGroupId,
      },
    };
  }

  componentWillMount() {
    this.setState({
      formConfig: this.initFormConfig(),
    });

    this.initSource();
  }

  static contextTypes = {
    store: PropTypes.object.isRequired,
  };

  initFormConfig() {
    this.setState({
      isSearch: 1,
    });

    const formConfig = {
      childItems: [
        {
          type: "select",
          options: [
            {
              text: "充电成功率", // '交流',
              value: "1",
            },
            {
              text: "启动成功率", // '直流',
              value: "0",
            },
          ],
          placeholder: "请选择设备类型",
          param: {
            name: "successType",
            type: "string",
          },
          labelName: "类型", // '成功率类型:',
          required: false,
          defaultValue: "1",
        },

        {
          type: "buttonGp", // 表单最终执行组
          buttonArr: [
            {
              btnType: "button",
              // icon: 'search',
              text: this.internationalization.btn1, // '查询',
              handler: (e, param) => {
                this.setState(
                  {
                    params: {
                      ...this.state.params,
                      ...param,
                    },
                  },
                  () => {
                    this.initSource();
                  },
                );
              },
            },
          ],
        },
      ],
      layout: "inline", // 设置布局 0： 横向布局， 1：纵向布局
      formTarget: "grid", // 表单提交类型，设置grid则为更新grid
      autoLoadGrid: !1, // 设置为false不触发加载grid
      context: this,
      tableKey: "taskTable",
    };

    return formConfig;
  }

  initSource = () => {
    this.handleGetDailyData();
    this.handleGetStopReasonData();
  };

  // 获取日数据
  handleGetDailyData = () => {
    this.setState({
      dayLoading: true,
    });
    fetchHandler(getEquSuccessRate, {
      ...this.state.params,
    }).then((res) => {
      if (res && res.code === "success") {
        this.setState({
          dailyDataList: res.data,
        });
      }
      this.setState({
        dayLoading: false,
      });
    });
  };

  // 获取停止原因数据源
  handleGetStopReasonData = () => {
    this.setState({
      stopReasonLoading: true,
    });
    fetchHandler(getStationOrEquStopReason, {
      ...this.state.params,
      isStubGroup: 1,
    }).then((res) => {
      if (res && res.code === "success") {
        this.setState({
          stopReasonDataList: res.data,
        });
      }
      this.setState({
        stopReasonLoading: false,
      });
    });
  };

  render() {
    const name = this.state.params.successType === "1" ? "充电成功率" : "启动成功率";
    const val = (
      <div
        className="analysis charge-success-rate-container"
        ref="chargSuccsessRate"
        style={{ height: "100%", overflowY: "auto", overflowX: "hidden" }}>
        <Affix target={() => this.refs.chargSuccsessRate}>
          <div className="analysis-title">
            <FormCore formConfig={this.state.formConfig} />
          </div>
        </Affix>

        {/* <div className="analysis-item">
          <div className="analysis-item-title analysis-title-font">
            {this.state.title}
          </div>
        </div> */}
        <ChargeSuccessDay
          {...this.props}
          dataSource={this.state.dailyDataList}
          setChooseDate={() => {}}
          chooseDate={moment()}
          title={`${this.state.title} 近7天${name}`}
          chartId="station-charge-success-day-chart"
          loading={this.state.dayLoading}
        />

        <StopReason
          {...this.props}
          title={`电站${this.state.title} 近7天订单停止原因`}
          dataSource={this.state.stopReasonDataList}
          chartId={["station-stop-reason-chart1", "station-stop-reason-chart2"]}
          loading={this.state.stopReasonLoading}
        />
        <Top100Equipment
          {...this.props}
          sortOrderOptions={SORT_ORDER_OPTIONS}
          sortTypeOptions={SORT_TYPE_OPTIONS}
          params={this.state.params}
          ref={(ref) => (this.top100EquRef = ref)}
        />
      </div>
    );
    return val;
  }
}

export default injectIntl(StationChargeDetail);



// WEBPACK FOOTER //
// ./src/AntD/pages/indicatorReport/chargeSuccessRate/stationChargeDetail.js